import React from 'react'
import {
  ContractorsTableFields,
  ContractorStatus,
  ContractorType,
  SubcontractorHeaderTypes,
} from './enums'

export const contractorStatusTitles = {
  [ContractorStatus.Active]: 'Active',
  [ContractorStatus.Deactivated]: 'Deactivated',
  [ContractorStatus.ExpiresSoon]: 'Expires Soon',
  [ContractorStatus.Unknown]: 'Unknown',
}

export const SPECIAL_HEADER_TYPES = [
  SubcontractorHeaderTypes.ALL,
  SubcontractorHeaderTypes.OWN,
  SubcontractorHeaderTypes.SUBCONTRACTOR,
]

export const contractorListHeaderTitles: Record<string, string> = {
  all: 'All contractors',
  own: 'Your contractors',
  subcontractor: "All MC's contractors",
}

export const contractorTypeTitles = {
  [ContractorType.Master]: 'Master',
  [ContractorType.Sub]: 'Sub',
  [ContractorType.IC]: 'IC',
}

export const contractorsTableHeaderTitles: { [key in ContractorsTableFields]: string } = {
  [ContractorsTableFields.externalId]: 'Contractors ID',
  [ContractorsTableFields.name]: 'Name',
  [ContractorsTableFields.contractorType]: 'Type',
  [ContractorsTableFields.vehicleType]: 'Vehicle Type',
  [ContractorsTableFields.status]: 'Status',
  [ContractorsTableFields.deactivationDetails]: 'Deactivation details',
  [ContractorsTableFields.onboardingFlow]: 'Assigned Template',
  [ContractorsTableFields.toReviewCount]: 'Needs review',
  [ContractorsTableFields.phone]: 'Phone number',
  [ContractorsTableFields.email]: 'Email',
  [ContractorsTableFields.tags]: 'Tag(s)',
  [ContractorsTableFields.lastActivity]: 'Last activity',
  [ContractorsTableFields.referral]: 'Referral',
  [ContractorsTableFields.masterContractorName]: 'Master contractor name',
  [ContractorsTableFields.expiresInDays]: 'Expires In',
  [ContractorsTableFields.recollections]: 'Recollection',
  [ContractorsTableFields.autoActivationEnabled]: 'Re-Activation',
  [ContractorsTableFields.dateOnboarded]: 'Date onboarded',
  [ContractorsTableFields.dateDeactivated]: 'Date deactivated',
}
